export enum ChannelActions {
    EMAIL = 'Email',
    CHAT = 'Chat',
    EDIT = 'Edit',
    VIDEO = 'Video',
    MENTION = 'Mention',
    CALL = 'Call'
   }